export enum RenderingStatus {
    Waiting = "pending",
    Ready = "success",
    Error = "error"
}

export const toRenderingStatus = {
    pending: RenderingStatus.Waiting,
    success: RenderingStatus.Ready,
    error: RenderingStatus.Error
};
